import Highcharts from 'highcharts'

Highcharts.setOptions({
  colors: ['#0a284b', '#ec5b60', '#4fb2c4', '#3d76ca', '#f1924a', '#f9d358'],
  lang: {
    numericSymbols: null,
    weekdays: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"],
    months: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"],
    shortMonths: ["jan", "febr", "mar", "apr", "maj", "jun", "jul", "aug", "sept", "okt", "nov", "dec"],
    thousandsSep: " ",
    decimalPoint: ",",
    contextButtonTitle: "Skriv ut/ladda ner",
    printChart: "Skriv ut",
    downloadPNG: "PNG-bild",
    downloadJPEG: "JPEG-bild",
    downloadPDF: "PDF-fil",
    downloadSVG: "SVG-fil",
    resetZoom: "Nollställ zoom",
    resetZoomTitle: "Nollställ zoom"
  },
  credits: false,
  chart: {
    spacing: [10, 0, 0, 0],
    style: {
      fontFamily: ['Arial', 'sans-serif'],
    },
    backgroundColor: 'transparent',
  },
  title: {
    align: 'left',
    style: {
      color: '#000',
      fontSize: '24px',
      fontWeight: 'bold',
    },
  },
  subtitle: {
    align: 'left',
    style: {
      color: '#000',
      fontSize: '16px',
      fontWeight: 'normal',
    },
  },
  tooltip: {
    backgroundColor: 'rgba(255,255,255,0.9)',
    shadow: false,
  },
  plotOptions: {
    series: {
      dataLabels: {
        allowOverlap: true,
        style: {
          fontSize: '16px',
          textOutline: 'none',
        },
      },
      animation: false,
      marker: {
        enabledThreshold: 20,
      },
      borderWidth: 0,
      groupPadding: 0.15,
    },
  },
  xAxis: {
    dateTimeLabelFormats: {
      millisecond: '%H:%M:%S.%L',
      second: '%H:%M:%S',
      minute: '%H:%M',
      hour: '%H:%M',
      day: '%e %b',
      week: '%e %b',
      month: '%b \'%y',
      year: '%Y',
    },
    lineColor: '#000',
    labels: {
      autoRotationLimit: 40,
      padding: 2,
      style: {
        fontSize: '16px',
        color: '#000',
      },
    },
    tickLength: 5,
    tickPixelInterval: 140,
    title: {
      style: {
        fontSize: '14px',
      },
    },
  },
  yAxis: {
    gridLineColor: '#E6E6E6',
    labels: {
      autoRotationLimit: 40,
      padding: 2,
      style: {
        fontSize: '12px',
        color: '#000',
      },
    },
    title: {
      style: {
        fontSize: '14px',
        color: '#000',
      },
    },
  },
});